import { StopStatus } from '../../../manage-shipments/data/types'
import {
  ConditionTypeEnum,
  DateOperatorEnum,
  IsBeforeAfterNotModifiersEnum,
  SingleSelectOperatorEnum,
  StringOperatorEnum
} from '../types'
import { commonFieldOptions } from './common-field-options'
import { TFieldOptions } from './field-options'

/**
 * Represents all fields available for autopilot rules for a shipment
 */
export const shipmentFieldOptions: TFieldOptions = {
  ...commonFieldOptions,
  'destination.appointment.end': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'destination.appointment.end',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Destination Latest',
    value: 'destination.appointment.end'
  },
  'destination.appointment.start': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'destination.appointment.start',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Destination Earliest',
    value: 'destination.appointment.start'
  },
  'destination.arrivalDateTime': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'destination.arrivalDateTime',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Destination Arrival',
    value: 'destination.arrivalDateTime'
  },
  'destination.departureDateTime': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'destination.departureDateTime',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Destination Departure',
    value: 'destination.departureDateTime'
  },
  'destination.eta': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'destination.eta',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'ETA Receiver',
    value: 'destination.eta'
  },
  'destination.status': {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: StopStatus.Arrived,
        operator: SingleSelectOperatorEnum.IS
      },
      conditionName: 'destination.status',
      conditionType: ConditionTypeEnum.SingleSelect
    },
    fieldType: ConditionTypeEnum.SingleSelect,
    name: 'Destination Stop Status',
    options: [
      {
        label: StopStatus.Arrived,
        value: StopStatus.Arrived
      },
      {
        label: StopStatus.Departed,
        value: StopStatus.Departed
      },
      {
        label: StopStatus.Enroute,
        value: StopStatus.Enroute
      }
    ],
    value: 'destination.status'
  },
  'destination.warehouse.address.city': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'destination.warehouse.address.city',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Destination City',
    value: 'destination.warehouse.address.city'
  },
  'destination.warehouse.address.stateCode': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'destination.warehouse.address.stateCode',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Destination State',
    value: 'destination.warehouse.address.stateCode'
  },
  'destination.warehouse.name': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.CONTAINS
      },
      conditionName: 'destination.warehouse.name',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Destination Warehouse Name',
    value: 'destination.warehouse.name'
  },
  'origin.appointment.end': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'origin.appointment.end',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Origin Latest',
    value: 'origin.appointment.end'
  },
  'origin.appointment.start': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'origin.appointment.start',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Origin Earliest',
    value: 'origin.appointment.start'
  },
  'origin.arrivalDateTime': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'origin.arrivalDateTime',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Origin Arrival',
    value: 'origin.arrivalDateTime'
  },
  'origin.departureDateTime': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'origin.departureDateTime',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'Origin Departure',
    value: 'origin.departureDateTime'
  },
  'origin.eta': {
    defaultConditionsConfig: {
      comparison: {
        comparisonIsAnotherField: false,
        modifier: IsBeforeAfterNotModifiersEnum.TODAY,
        operator: DateOperatorEnum.IS
      },
      conditionName: 'origin.eta',
      conditionType: ConditionTypeEnum.Date
    },
    fieldType: ConditionTypeEnum.Date,
    name: 'ETA Shipper',
    value: 'origin.eta'
  },
  'origin.status': {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: StopStatus.Arrived,
        operator: SingleSelectOperatorEnum.IS
      },
      conditionName: 'origin.status',
      conditionType: ConditionTypeEnum.SingleSelect
    },
    fieldType: ConditionTypeEnum.SingleSelect,
    name: 'Origin Stop Status',
    options: [
      {
        label: StopStatus.Arrived,
        value: StopStatus.Arrived
      },
      {
        label: StopStatus.Departed,
        value: StopStatus.Departed
      },
      {
        label: StopStatus.Enroute,
        value: StopStatus.Enroute
      }
    ],
    value: 'origin.status'
  },
  'origin.warehouse.address.city': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'origin.warehouse.address.city',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Origin City',
    value: 'origin.warehouse.address.city'
  },
  'origin.warehouse.address.stateCode': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'origin.warehouse.address.stateCode',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Origin State',
    value: 'origin.warehouse.address.stateCode'
  },
  'origin.warehouse.name': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.CONTAINS
      },
      conditionName: 'origin.warehouse.name',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Origin Warehouse Name',
    value: 'origin.warehouse.name'
  }
}

/**
 * Represents all date fields available for autopilot rules for a shipment
 *
 * @returns {IFieldConfig[]} an array of date field options
 */
export const shipmentDateFieldOptions = Object.entries(shipmentFieldOptions)
  .filter(([, value]) => value.fieldType === ConditionTypeEnum.Date)
  .map(([, value]) => value)
  .sort((a, b) => a.name.localeCompare(b.name))
